import { useCallback } from 'react';

import { useLazyGetOrganiseDocumentQuery } from 'store/api/organiseDocument';

/** Fetches an uploaded document's download URL, keeping the same function while the care circle stays the same. */
export const useDocumentUrl = (careCircleId: string | undefined) => {
  const [getDocument] = useLazyGetOrganiseDocumentQuery();

  return useCallback(
    async (documentId: string): Promise<string | undefined> => {
      if (!careCircleId) return undefined;
      const res = await getDocument({ careCircleId, documentId });
      return res.data?.downloadUrl;
    },
    [careCircleId, getDocument],
  );
};
